/**
 * 装饰器
 */

import {debounce as _debounce, throttle as _throttle} from 'lodash-es';

export function throttle(wait: number, options = {}) {
    // @ts-ignore
    return function (target, name, descriptor) {
        const fn = descriptor.value;
        descriptor.value = _throttle(fn, wait, options);
        return descriptor;
    };
}

export function debounce(wait: number, options = {}) {
    // @ts-ignore
    return function (target, name, descriptor) {
        const fn = descriptor.value;
        descriptor.value = _debounce(fn, wait, options);
        return descriptor;
    };
}
